const ALLOWED_TAGS = new Set([
  "p", "br", "strong", "b", "em", "i", "u",
  "ul", "ol", "li", "span", "div",
]);

const MAX_ANSWER_HTML_LENGTH = 12000;

export const sanitizeFaqHtml = (html) => {
  if (!html || typeof html !== "string") {
    return "";
  }

  let out = html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
    .replace(/<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi, "")
    .replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/(href|src)\s*=\s*(['"])\s*javascript:[\s\S]*?\2/gi, "$1=$2#$2");

  out = out.replace(/<\/?([a-z0-9]+)([^>]*)>/gi, (match, tag, attrs) => {
    const t = tag.toLowerCase();
    if (!ALLOWED_TAGS.has(t)) {
      return "";
    }
    if (t === "br") {
      return "<br />";
    }
    if (match.startsWith("</")) {
      return `</${t}>`;
    }

    let safeAttrs = "";
    const style = attrs.match(/style\s*=\s*(['"])(.*?)\1/i);
    if (style) {
      const filtered = style[2]
        .split(";")
        .map((part) => part.trim())
        .filter((part) =>
          /^(font-weight|font-style|text-decoration)\s*:/i.test(part)
        )
        .join("; ");
      if (filtered) {
        safeAttrs += ` style="${filtered}"`;
      }
    }
    return `<${t}${safeAttrs}>`;
  });

  return out.slice(0, MAX_ANSWER_HTML_LENGTH);
};

export const faqAnswerHasText = (html) =>
  Boolean(sanitizeFaqHtml(html).replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, " ").trim());

export const faqAnswerPlainText = (html) =>
  sanitizeFaqHtml(html)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|div|li|ul|ol)>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

export const plainTextToFaqHtml = (value) => {
  const text = String(value || "");
  if (!text.trim()) {
    return "";
  }
  if (/<[a-z][\s\S]*>/i.test(text)) {
    return sanitizeFaqHtml(text);
  }
  return text
    .split(/\n/)
    .map((line) => `<p>${line.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") || "<br />"}</p>`)
    .join("");
};
